export enum BadgeColor {
  Bronze = 'bronze',
  Silver = 'silver',
  Gold = 'gold',
}
